export const getIsInitialOperatorRunsPollLoading = (state) => {
  return !!state?.recentOperatorRunsPoll?.isInitialPollLoading;
};
